<template>
  <v-container>
    <v-row justify="center mt-4">
      <v-col
        xl="6"
        lg="8"
        md="10"
        cols="12"
      >
        <v-card
          :elevation="0"
          outlined
        >
          <v-card-text>
            <v-list class="menu">
              <template v-for="(item, i) in settingsMenuItems(isBillingPageAllowed)">
                <v-list-item
                  v-if="item.subitems === undefined"
                  :key="`settings_${i}`"
                  :to="item.link"
                  :disabled="!item.link"
                  link
                >
                  <v-list-item-title class="font-weight-bold">
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-group
                  v-else
                  :key="`settings_${i}`"
                  no-action
                  :class="[{'mt-4': i > 0}]"
                  color="none"
                  value="true"
                >
                  <template #activator>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-bold">
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list-item
                    v-for="(subitem, j) in item.subitems"
                    :key="`settings_${i}_${j}`"
                    :class="['pl-10', {'mb-4': j === item.subitems.length -1}]"
                    :to="subitem.link"
                    :disabled="!subitem.link"
                    link
                  >
                    <v-list-item-title>{{ subitem.text }}</v-list-item-title>
                  </v-list-item>
                </v-list-group>
              </template>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { settingsMenuItems } from '@/util/menu';
import store from '@/store/store';

const isBillingPageAllowed = computed(() => store.getters.isBillingPageAllowed);

</script>
